$(document).ready(function () {
  const isMobile = document.documentElement.clientWidth < 769

  if (isMobile) {
    const ourOfficesSwiper = new Swiper('.offices-swiper', {
      slidesPerView: 1.2,
      spaceBetween: 24,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    })
  }
})

